import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";

const StudentPortal = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const cardItems = [
        {
            title: "New Admission",
            desc: "Add new student admission details.",
            icon: "bi-person-plus",
            path: "/student/add",
        },
        {
            title: "Update Student Profile",
            desc: "Search and update existing student information.",
            icon: "bi-pencil-square",
            path: "/idcard/student",
        },
        {
            title: "Bulk Student Upload",
            desc: "Upload multiple students using an Excel file.",
            icon: "bi-file-earmark-excel",
            path: "/student/bulk-upload",
        },
        {
            title: "Blank Admission Form",
            desc: "View or print a blank admission form.",
            icon: "bi-file-earmark-text",
            path: "/addmission/form",
        },
    ];

    return (
        <>
            {/* ✅ Loader */}
            {loading && (
                <div
                    className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-light bg-opacity-75"
                    style={{ zIndex: 9999 }}
                >
                    <div className="spinner-border text-primary display-4"></div>
                </div>
            )}

            <div className="layout-wrapper layout-content-navbar">
                <div className="layout-container">
                    <div className="no-print">
                        <Header />
                    </div>
                    <div className="layout-page">
                        <div className="no-print">
                            <Nav />
                        </div>
                        <div className="content-wrapper">
                            <div className="container-fluid py-4">

                                <div className="container py-4">
                                    <div className="card mb-3">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h2 className="fw-bold mb-4 text-primary">Student Portal</h2>
                                                <button
                                                    onClick={(e) => {
                                                        navigate(-1)
                                                    }}
                                                    className="btn btn-outline-primary"
                                                >
                                                    <i className="bi bi-arrow-left-circle me-1"></i>
                                                    Back
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row g-4">
                                        {cardItems.map((item, i) => (
                                            <div className="col-md-3 col-sm-6" key={i}>
                                                <div
                                                    className="card h-100 p-4 text-center shadow-sm border-0 student-card-hover"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => navigate(item.path)}
                                                >
                                                    <div className="mb-3">
                                                        <i
                                                            className={`${item.icon} fs-1 text-primary`}
                                                        ></i>
                                                    </div>
                                                    <h5 className="fw-bold">{item.title}</h5>
                                                    <p className="text-muted small">{item.desc}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <style>
                {`
          .student-card-hover {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
            border-radius: 12px;
          }
          .student-card-hover:hover {
            transform: translateY(-5px);
            box-shadow: 0px 6px 20px rgba(0,0,0,0.1);
          }
        `}
            </style>
        </>
    );
};

export default StudentPortal;
